import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./UserList.scss";
import CustomModal from "../../common-components/modal/Modal.jsx";
import { Container, Row, Col, Form, Alert } from "react-bootstrap";
import InputField from "../../common-components/input-field/Input-field.jsx";
import Select from "../../common-components/select/Select.jsx";
import { getUsersList } from "../../state/reducers/userList";


const roleOptions = [
  { label: "Admin", value: "Admin", disabled: false },
  { label: "User", value: "User", disabled: false }
];

function UserList() {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.userList);
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  useEffect(() => {
    dispatch(getUsersList())
      .unwrap()
      .then((response) => {
        // Transform API data to match component structure
        const transformedUsers = response.map((user, index) => ({
          id: index + 1, // Add an id since API doesn't provide one
          name: user.fullname,
          username: user.username,
          email: user.email,
          role: user.role || "Not Assigned", // Handle null role
          isActive: user.status === "Active"
        }));
        setUsers(transformedUsers);
      })
      .catch((error) => {
        console.error("Failed to fetch users:", error);
      });
  }, [dispatch]);

  const handleDelete = (user) => {
    setUserToDelete(user);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    setUsers(users.filter(user => user.id !== userToDelete.id));
    setShowDeleteModal(false);
    setUserToDelete(null);
  };

  const handleEdit = (user) => {
    setEditingUser({ ...user });
  };

  const handleSave = () => {
    console.log("Save User");
    setUsers(users.map(user => user.id === editingUser.id ? editingUser : user));
    setEditingUser(null);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditingUser(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleCancel = () => {
    setEditingUser(null);
  };

  const modalContent = (
    <p>Are you sure you want to delete the user &quot;{userToDelete?.name}&quot;?</p>
  );

  const modalFooter = (
    <>
      <button onClick={() => setShowDeleteModal(false)} className="btn btn-primary me-3">Cancel</button>
      <button onClick={confirmDelete} className="btn btn-primary">Delete</button>
    </>
  );

  return (
    <div className="page-wrapper user-list">
      {editingUser ? (
        <Container className="edit-form">
          <Row>
            <Col>
              <h2 className="page-title">Edit User</h2>
            </Col>
          </Row>
          <Form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
            <Row>
              <Col md={6}>
                <InputField
                  id="name"
                  name="name"
                  label="Name"
                  value={editingUser.name}
                  onChange={handleChange}
                  layoutStyle="horizontal"
                  labelColSize={4}
                  inputColSize={8}
                  required
                />
              </Col>
              <Col md={6}>
                <InputField
                  id="username"
                  name="username"
                  label="Username"
                  value={editingUser.username}
                  onChange={handleChange}
                  layoutStyle="horizontal"
                  labelColSize={4}
                  inputColSize={8}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <InputField
                  id="email"
                  name="email"
                  label="Email"
                  value={editingUser.email}
                  onChange={handleChange}
                  layoutStyle="horizontal"
                  labelColSize={4}
                  inputColSize={8}
                  required
                />
              </Col>
              <Col md={6}>
                <Select
                  id="role"
                  name="role"
                  label="Role"
                  value={editingUser.role}
                  onChange={handleChange}
                  layoutStyle="horizontal"
                  labelColSize={4}
                  inputColSize={8}
                  options={roleOptions}
                  placeholder="Select a role"
                  required
                />
              </Col>  
            </Row>
            
            <div>
              <label htmlFor="isActive">
                <input id="isActive" type="checkbox" name="isActive" checked={editingUser.isActive} onChange={handleChange} />
                Active
              </label>
            </div>
            <Row className="form-actions">
              <Col className="text-end">
                <button type="submit" className="btn btn-primary me-3">Save</button>
                <button type="button" className="btn btn-primary" onClick={handleCancel}>Cancel</button>
              </Col>
            </Row>
          </Form>
        </Container>
      ) : (
        <Container className="user-list">
          <Row>
            <Col>
              <h2 className="page-title">Users List</h2>
              {error && (
                <Alert variant="danger">
                  {error}
                </Alert>
              )}
              {loading ? (
                <p>Loading user list...</p>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th width="20%">Name</th>
                      <th width="20%">Username</th>
                      <th>Email</th>
                      <th width="8%">Role</th>
                      <th width="8%">Status</th>
                      <th width="16%">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(user => (
                      <tr key={user.id}>
                        <td>{user.name}</td>
                        <td>{user.username}</td>
                        <td>{user.email}</td>
                        <td>{user.role}</td>
                        <td>{user.isActive ? "Active" : "Inactive"}</td>
                        <td>
                          <button onClick={() => handleEdit(user)} className="btn btn-primary me-2">Edit</button>
                          <button onClick={() => handleDelete(user)} className="btn btn-primary">Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              
            </Col>
          </Row>
        </Container>
      )}
      <CustomModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        heading="Confirm Delete"
        content={modalContent}
        footer={modalFooter}
      />
    </div>
  );
}

export default UserList;